import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import { Link, useLocation } from 'react-router-dom';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import BatteryChargingFullRoundedIcon from '@mui/icons-material/BatteryChargingFullRounded';
import BuildRoundedIcon from '@mui/icons-material/BuildRounded';


const MenuContent = ({ onNavigate }) => {
  const location = useLocation();

  const mainListItems = [
    { text: 'Overview', icon: <HomeRoundedIcon />, path: '/dashboard' },
    { text: 'Charging', icon: <BatteryChargingFullRoundedIcon />, path: '/dashboard/charging' },
    { text: 'Statistics', icon: <AnalyticsRoundedIcon />, path: '/dashboard/statistics' },
    { text: 'Maintenance', icon: <BuildRoundedIcon />, path: '/dashboard/maintenance' },
  ];

  const secondaryListItems = [
    { text: 'Settings', icon: <SettingsRoundedIcon />, path: '/dashboard/settings' },
    {
      text: 'About',
      icon: <InfoRoundedIcon />,
      link: 'mailto:viveksupmanyu@gmail.com'
    },
    {
      text: 'Feedback',
      icon: <HelpRoundedIcon />,
      link: 'https://github.com/Slv-WebTech'
    },
  ];

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              onClick={onNavigate}
              sx={(theme) => ({
                borderRadius: 3,
                mb: 0.5,
                px: 1.25,
                '&.Mui-selected': {
                  background: alpha(theme.palette.primary.main, 0.16),
                  border: '1px solid',
                  borderColor: alpha(theme.palette.primary.main, 0.28),
                  boxShadow: `0 10px 22px ${alpha(theme.palette.primary.main, 0.12)}`,
                },
                '&.Mui-selected:hover': {
                  background: alpha(theme.palette.primary.main, 0.2),
                },
              })}
            >
              <ListItemIcon sx={{ minWidth: 38 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              component={item.link ? 'a' : Link}
              to={item.path}
              href={item.link}
              target={item.link?.startsWith('http') ? '_blank' : undefined}
              rel={item.link?.startsWith('http') ? 'noopener noreferrer' : undefined}
              selected={item.path ? location.pathname === item.path : false}
              onClick={onNavigate}
              sx={(theme) => ({
                borderRadius: 3,
                mb: 0.5,
                px: 1.25,
                '&.Mui-selected': {
                  background: alpha(theme.palette.primary.main, 0.16),
                  border: '1px solid',
                  borderColor: alpha(theme.palette.primary.main, 0.28),
                  boxShadow: `0 10px 22px ${alpha(theme.palette.primary.main, 0.12)}`,
                },
                '&.Mui-selected:hover': {
                  background: alpha(theme.palette.primary.main, 0.2),
                },
              })}
            >
              <ListItemIcon sx={{ minWidth: 38 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
};

MenuContent.propTypes = {
  onNavigate: PropTypes.func,
};

export default MenuContent;
